import { createFileRoute, Outlet } from "@tanstack/react-router";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";
import { organisationQueryOptions } from "@/server/organisations";

export const Route = createFileRoute("/_dashboard/emails/organisations/$orgId")({
  component: OrganisationEmailsDetailComponent,
  loader: async ({ params, context }) => {
    const queryOptions = organisationQueryOptions(Number(params.orgId));
    await context.queryClient.prefetchQuery(queryOptions);
    const organisation = context.queryClient.getQueryData(queryOptions.queryKey) as { name?: string } | undefined;
    return {
      crumb: organisation?.name || "Organisation",
      dehydratedState: dehydrate(context.queryClient),
    };
  },
});

function OrganisationEmailsDetailComponent() {
  const { dehydratedState } = Route.useLoaderData();

  return (
    <HydrationBoundary state={dehydratedState}>
      <Outlet />
    </HydrationBoundary>
  );
}
